export default __webpack_public_path__ + "static/media/Rules of the Backstreets.8ba8662f.png";